import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ErrorBoundary } from "./shell/ErrorBoundary";
import "./styles.css";

/**
 * The outermost boundary.
 *
 * Without it, anything that throws during the shell's own render leaves an empty
 * window — a title bar and a grey rectangle, with the reason only in a console
 * nobody has open in a packaged app. A blank window is the least debuggable
 * failure there is, and it is the one a store selector or a bad import produces.
 * The panel boundaries below this one still catch their own.
 */
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary label="ADS Desk">
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
